import React from 'react';
import { Radar } from 'lucide-react';
import { useContent } from '../i18n/LanguageContext';

export default function Footer() {
  const c = useContent();
  const f = c.footer;
  const scrollTo = (href) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };
  return (
    <footer className="bg-slate-950 text-slate-300">
      <div className="lt-container py-16">
        <div className="grid md:grid-cols-4 gap-10">
          <div className="md:col-span-2 max-w-sm">
            <div className="flex items-center gap-2">
              <span className="grid place-items-center w-9 h-9 rounded-xl bg-teal-600 text-white"><Radar className="w-5 h-5" /></span>
              <span className="font-display text-xl font-bold text-white">LOGI<span className="text-teal-400">TAG</span></span>
            </div>
            <p className="mt-4 text-sm text-slate-400 leading-relaxed">{f.tagline}</p>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white">{f.navTitle}</h4>
            <ul className="mt-4 space-y-2.5">
              {c.nav.map((l) => (
                <li key={l.href}>
                  <button onClick={() => scrollTo(l.href)} className="text-sm text-slate-400 hover:text-teal-400 transition-colors">{l.label}</button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-display font-semibold text-white">{f.contactTitle}</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li>{c.contact.address}</li>
              <li><a href={`mailto:${c.contact.email}`} className="hover:text-teal-400 transition-colors">{c.contact.email}</a></li>
              <li><a href={`tel:${c.contact.phone.replace(/[^+0-9]/g, '')}`} className="hover:text-teal-400 transition-colors">{c.contact.phone}</a></li>
            </ul>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-sm text-slate-500">© {new Date().getFullYear()} LOGITAG. {f.rights}</p>
          <p className="text-xs text-slate-600">{f.madeIn}</p>
        </div>
      </div>
    </footer>
  );
}
